<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal">
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar método de pago' : 'Nuevo método de pago' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <form class="mod-modal-body" @submit.prevent="handleSubmit">
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <div class="mod-field">
            <label for="CMetodoPago">Clave <span class="mod-required">*</span></label>
            <input
              id="CMetodoPago"
              v-model.trim="form.CMetodoPago"
              type="text"
              maxlength="50"
              required
              :disabled="isEdit"
              placeholder="Ej. PUE"
            >
          </div>

          <div class="mod-field">
            <label for="Descripcion">Descripción <span class="mod-required">*</span></label>
            <input
              id="Descripcion"
              v-model.trim="form.Descripcion"
              type="text"
              maxlength="200"
              required
              placeholder="Pago en una sola exhibición"
            >
          </div>

          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input v-model="form.EsActivo" type="checkbox">
              <span>Activo</span>
            </label>
          </div>
        </div>

        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear método de pago' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import metodoPagoService from './metodopago.service';
import { createSatMetodoPago } from './metodopago.model';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';

export default {
  name: 'MetodoPagoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false },
    mode: { type: String, default: 'empresa' }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createSatMetodoPago(),
      saving: false,
      error: null
    };
  },
  created() {
    this.form = this.isEdit && this.item ? { ...this.item } : createSatMetodoPago();
    if (this.mode === 'empresa' && !this.form.EmpresaId) {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!this.form.CMetodoPago || !this.form.Descripcion) {
        this.error = 'Clave y descripción son obligatorias';
        this.saving = false;
        return;
      }

      try {
        const result = this.mode === 'global'
          ? await metodoPagoService.guardarGlobal(this.form)
          : await metodoPagoService.guardarEmpresa(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar método de pago:', e);
        this.error = 'Error de conexión con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
